import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  height: "24px",
  width: "24px",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25.811 25.811",
  style: {"fill":"currentColor"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      id: "zoom-out",
      transform: "translate(-3.75 -3.75)"
    }, [
      _createElementVNode("path", {
        id: "Tracé_110",
        "data-name": "Tracé 110",
        d: "M25.834,15.167A10.667,10.667,0,1,1,15.167,4.5,10.667,10.667,0,0,1,25.834,15.167Z",
        transform: "translate(0 0)",
        fill: "none",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5"
      }),
      _createElementVNode("path", {
        id: "Tracé_111",
        "data-name": "Tracé 111",
        d: "M30.775,30.775l-5.8-5.8",
        transform: "translate(-2.275 -2.275)",
        fill: "none",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5"
      }),
      _createElementVNode("path", {
        id: "Tracé_113",
        "data-name": "Tracé 113",
        d: "M12,16.5h8.252",
        transform: "translate(-0.959 -1.335)",
        fill: "none",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1"
      })
    ], -1)
  ])))
}